import {
  GeneralizedItem,
  GoogleItemType,
  ALLSumBlocks,
  PromaItemType,
  AnyItemType,
  PromaBlocks
} from '../items/itemDefinitions';
import { DSTFields, DSTFieldType, ViewFilterFields } from '../items/fieldDefinitions';

export enum LayerBy {
  company
}

export enum ColorBy {
  none,
  item,
  parent,
  tag
}

export interface ShowItem {
  itemType: GoogleItemType | PromaItemType;
  status: true | false | null;
}

export interface DSTView {
  filterItems: GeneralizedItem[] | null;
  viewFilterFields: ViewFilterFields[] | [];
  timeFilter: string | null;
  filterByMe?: boolean;
  showItems: ShowItem[];
  simpleItemFields?: { [key: string]: DSTFieldType[] };
  tabs: boolean;
  colorBy: ColorBy;
  layerBy: LayerBy;
  title: string;
  description: string | null;
  id: number;
  user: string;
  presetBlockList?: any;
  hideFilterFields: boolean;
  filterPromaData?: boolean;
  absoluteFilterPosition?: any;
  filterableItemTypes?: AnyItemType[];
}

export const defaultViews: DSTView[] = [
  {
    filterItems: [],
    viewFilterFields: [],
    timeFilter: null,
    filterByMe: true,
    showItems: [
      { itemType: GoogleItemType.Calendar, status: false },
      { itemType: GoogleItemType.Event, status: false }
    ],
    simpleItemFields: DSTFields,
    tabs: true,
    colorBy: ColorBy.none,
    layerBy: LayerBy.company,
    title: 'Loading...',
    description: 'Loading...',
    id: 1,
    user: 'defaultView',
    hideFilterFields: false
  },
  {
    filterItems: [],
    viewFilterFields: [ViewFilterFields.selectRisk],
    timeFilter: null,
    filterByMe: true,
    showItems: [
      { itemType: GoogleItemType.Calendar, status: false },
      { itemType: GoogleItemType.Event, status: false }
    ],
    simpleItemFields: DSTFields,
    tabs: true,
    colorBy: ColorBy.none,
    layerBy: LayerBy.company,
    title: 'Tilaajan kustannusriskien arviointiharjoite 8/2021',
    description: 'The default view for now',
    id: 1,
    user: 'defaultView',
    hideFilterFields: false
  },
  {
    filterItems: [],
    viewFilterFields: [ViewFilterFields.selectBlock, ViewFilterFields.selectSimSheet],
    timeFilter: null,
    filterByMe: true,
    showItems: [
      { itemType: GoogleItemType.Calendar, status: false },
      { itemType: GoogleItemType.Event, status: true }
    ],
    simpleItemFields: DSTFields,
    tabs: true,
    colorBy: ColorBy.none,
    layerBy: LayerBy.company,
    title: 'Monte Carlo -simulaatiot',
    description: '',
    id: 2,
    user: 'defaultView',
    hideFilterFields: false
  },
  {
    filterItems: [],
    viewFilterFields: [],
    timeFilter: null,
    filterByMe: true,
    showItems: [
      { itemType: GoogleItemType.Calendar, status: false },
      { itemType: GoogleItemType.Event, status: true }
    ],
    simpleItemFields: DSTFields,
    tabs: true,
    colorBy: ColorBy.none,
    layerBy: LayerBy.company,
    title: 'Google-kalenterinäkymä',
    description: '',
    id: 3,
    user: 'defaultView',
    hideFilterFields: false
  },
  {
    filterItems: [],
    viewFilterFields: [ViewFilterFields.selectBlock, ViewFilterFields.selectKvPhase],
    timeFilter: null,
    filterByMe: true,
    showItems: [
      { itemType: GoogleItemType.Calendar, status: false },
      { itemType: GoogleItemType.Event, status: false }
    ],
    simpleItemFields: DSTFields,
    tabs: true,
    colorBy: ColorBy.none,
    layerBy: LayerBy.company,
    title: 'Viittaukset riskien ja mahdollisuuksien välillä',
    description: '',
    id: 4,
    user: 'defaultView',
    presetBlockList: ALLSumBlocks,
    hideFilterFields: false
  },
  {
    filterItems: [],
    viewFilterFields: [
      ViewFilterFields.selectBlock,
      ViewFilterFields.selectKvPhase,
      ViewFilterFields.selectValueType,
      ViewFilterFields.selectAllianceVsClient,
      ViewFilterFields.selectRiskType
    ],
    timeFilter: null,
    filterByMe: true,
    showItems: [
      { itemType: GoogleItemType.Calendar, status: false },
      { itemType: GoogleItemType.Event, status: false }
    ],
    simpleItemFields: DSTFields,
    tabs: true,
    colorBy: ColorBy.none,
    layerBy: LayerBy.company,
    title: 'Riskihierarkia (RBS)',
    description: '',
    id: 5,
    user: 'defaultView',
    presetBlockList: ALLSumBlocks,
    hideFilterFields: false
  },
  {
    filterItems: [],
    viewFilterFields: [ViewFilterFields.selectBlock, ViewFilterFields.viewTime],
    timeFilter: null,
    filterByMe: true,
    showItems: [
      { itemType: PromaItemType.FinalGoal, status: true },
      { itemType: PromaItemType.Milestone, status: true },
      { itemType: PromaItemType.Achievement, status: true },
      { itemType: PromaItemType.Task, status: true }
    ],
    simpleItemFields: DSTFields,
    tabs: true,
    colorBy: ColorBy.none,
    layerBy: LayerBy.company,
    title: 'PROMA-hierarkia',
    description: '',
    id: 6,
    user: 'defaultView',
    presetBlockList: PromaBlocks,
    hideFilterFields: false
  },
  {
    filterItems: [],
    viewFilterFields: [
      ViewFilterFields.cameraTime,
      ViewFilterFields.viewTime,
      ViewFilterFields.itemFilter
    ],
    timeFilter: null,
    filterByMe: true,
    showItems: [
      { itemType: PromaItemType.Task, status: true },
      { itemType: PromaItemType.Achievement, status: true },
      { itemType: PromaItemType.Milestone, status: true },
      { itemType: PromaItemType.FinalGoal, status: true }
    ],
    simpleItemFields: DSTFields,
    tabs: true,
    colorBy: ColorBy.none,
    layerBy: LayerBy.company,
    title: 'Kapa-kartta',
    description: '',
    id: 7,
    user: 'defaultView',
    hideFilterFields: true,
    absoluteFilterPosition: true,
    filterableItemTypes: [GoogleItemType.Folder]
  },
  {
    filterItems: [],
    viewFilterFields: [],
    timeFilter: null,
    filterByMe: true,
    showItems: [],
    simpleItemFields: DSTFields,
    tabs: true,
    colorBy: ColorBy.none,
    layerBy: LayerBy.company,
    title: 'Suunnittelun valmiusasteet',
    description: '',
    id: 8,
    user: 'defaultView',
    presetBlockList: PromaBlocks,
    filterPromaData: false,
    hideFilterFields: false
  },
  {
    filterItems: [],
    viewFilterFields: [ViewFilterFields.viewTime],
    timeFilter: null,
    filterByMe: true,
    showItems: [
      { itemType: PromaItemType.FinalGoal, status: true },
      { itemType: PromaItemType.Milestone, status: true },
      { itemType: PromaItemType.Achievement, status: true },
      { itemType: PromaItemType.Task, status: true }
    ],
    simpleItemFields: DSTFields,
    tabs: true,
    colorBy: ColorBy.none,
    layerBy: LayerBy.company,
    title: 'PROMA Gantt',
    description: '',
    id: 9,
    user: 'defaultView',
    presetBlockList: PromaBlocks,
    hideFilterFields: true
  },
  {
    filterItems: [],
    viewFilterFields: [],
    timeFilter: null,
    filterByMe: true,
    showItems: [
      { itemType: GoogleItemType.Calendar, status: false },
      { itemType: GoogleItemType.Event, status: true }
    ],
    simpleItemFields: DSTFields,
    tabs: true,
    colorBy: ColorBy.none,
    layerBy: LayerBy.company,
    title: 'Karaatin oman henkilöstön vahvuus',
    description: '',
    id: 10,
    user: 'defaultView',
    hideFilterFields: false
  }
];
